<template>
  <div>
    <!-- <div class="card" v-if="!isLoadingDashboard">
      <div class="card-body">
        <div>
         <div class="font-weight-bold text-dark font-size-24">IDR {{ totalWeeklySales }}</div>
          <div><h5>Weekly Sales</h5></div>
          <vue-chartist class="height-200 ct-hidden-points" type="Line" :data="dataCart" :options="optionsCart" />
        </div>
      </div>
    </div> -->
    <div class="row" v-if="!isLoadingDashboard">
      <div class="col-xl">
        <div class="row">
          <div class="col-xl-6">
            <!-- <router-link :to="{ path: '/orders', query: {payload: 3} }"> -->
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-xl-3">
                      <i class="fe fe-clock fa-4x"></i>
                    </div>
                    <div class="col-xl align-self-center">
                      <h5 class="mb-0">Pending Orders</h5>
                      <p class="mb-0">{{ !dashboard.order_summary.order_pending_qty ? 0 : dashboard.order_summary.order_pending_qty }}</p>
                    </div>
                  </div>
                </div>
              </div>
            <!-- </router-link> -->
          </div>
          <div class="col-xl-6">
            <!-- <router-link :to="{ path: '/orders', query: {payload: 4} }"> -->
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-xl-3">
                      <i class="fe fe-loader fa-4x"></i>
                    </div>
                    <div class="col-xl align-self-center">
                      <h5 class="mb-0">On Process Orders</h5>
                      <p class="mb-0">{{ !dashboard.order_summary.order_onprocess_qty ? 0 : dashboard.order_summary.order_onprocess_qty }}</p>
                    </div>
                  </div>
                </div>
              </div>
            <!-- </router-link> -->
          </div>
          <div class="col-xl-6">
            <!-- <router-link :to="{ path: '/orders', query: {payload: 5} }"> -->
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-xl-3">
                      <i class="fe fe-check-circle fa-4x"></i>
                    </div>
                    <div class="col-xl align-self-center">
                      <h5 class="mb-0">Completed Orders</h5>
                      <p class="mb-0">{{ !dashboard.order_summary.order_completed_qty ? 0 : dashboard.order_summary.order_completed_qty }}</p>
                    </div>
                  </div>
                </div>
              </div>
            <!-- </router-link> -->
          </div>
          <div class="col-xl-6">
            <!-- <router-link :to="{ path: '/orders', query: {payload: 8} }"> -->
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-xl-3">
                      <i class="fe fe-x-circle fa-4x"></i>
                    </div>
                    <div class="col-xl align-self-center">
                      <h5 class="mb-0">Canceled Orders</h5>
                      <p class="mb-0">{{ !dashboard.order_summary.order_retourreq_qty ? 0 : dashboard.order_summary.order_retourreq_qty }}</p>
                    </div>
                  </div>
                </div>
              </div>
            <!-- </router-link> -->
          </div>
          <!-- <div class="col-xl-6">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-xl-3">
                    <i class="fe fe-sidebar fa-4x"></i>
                  </div>
                  <div class="col-xl align-self-center">
                    <h5 class="mb-0">E-Wallet</h5>
                    <p class="mb-0">IDR. {{ !dashboard.commissions.ewallet ? 0 : dashboard.commissions.ewallet }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div class="col-xl-6">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-xl-3">
                    <i class="fe fe-dollar-sign fa-4x"></i>
                  </div>
                  <div class="col-xl align-self-center">
                    <h5 class="mb-0">Total Commision</h5>
                    <p class="mb-0">IDR. {{ !dashboard.commissions.commission ? 0 : dashboard.commissions.commission }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div class="col-xl-6">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-xl-3">
                    <i class="fe fe-refresh-cw fa-4x"></i>
                  </div>
                  <div class="col-xl align-self-center">
                    <h5 class="mb-0">Refund Request</h5>
                    <p class="mb-0">{{ !dashboard.order_summary.order_retourreq_qty ? 0 : dashboard.order_summary.order_retourreq_qty }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div class="col-xl-6">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-xl-3">
                    <i class="fe fe-credit-card fa-4x"></i>
                  </div>
                  <div class="col-xl align-self-center">
                    <h5 class="mb-0">Commisions  On Coming Transaction</h5>
                    <p class="mb-0">IDR. {{ !dashboard.commissions.commission_should_pay ? 0 : dashboard.order_summary.order_retourreq_qty }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="col-xl-4">
        <div class="row">
          <div class="col-xl-12">
            <div class="card">
              <div class="card-body">
                <h5>Top Selling Product</h5>
                <div v-if="dashboard.top_selling_items.length === 0"> Not Found Top Selling Product </div>
                <div v-if="dashboard.top_selling_items.length > 0" class="mt-3">
                  <ul>
                    <li v-for="(item, index) in dashboard.top_selling_items.slice(0,3)" :key="index" class="mt-2">
                      <div> {{ item.name }} </div>
                      <div class="text-muted"> Total Sold: {{ item.total_sold }} item </div>
                    </li>
                  </ul>
                  <!-- <div>
                    <img :src="dashboard.top_selling_items[0].url" style="width: 82%; margin-left: 2rem" alt="">
                  </div>
                  <div>
                    <strong>{{ dashboard.top_selling_items[0].name }}</strong>
                  </div>
                  <div>
                    <p> Total Sold: {{ dashboard.top_selling_items[0].total_sold }} item </p>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="!isLoadingDashboard">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h5>Recent Orders</h5>
            <div class="row" v-if="dashboard.recent_sold_items.length > 0">
              <div class="col-xl-12" v-for="(items, index) in dashboard.recent_sold_items" v-bind:key="`${items.product_id}-${index}`">
                <div class="card mb-3" style="width: 100%;">
                  <div class="row no-gutters">
                    <div class="col-xl-2">
                      <img :src="items.url" class="card-img" style="width: 100%" alt="">
                    </div>
                    <div class="col-xl-8">
                      <div class="card-body">
                        <h5 class="mb-0">{{ items.name }}</h5>
                        <b-badge class="mr-2 mb-4" variant="primary">{{ items.status }}</b-badge>
                        <p class="text-muted">{{ items.description.detail_shortdesc }}</p>
                        <p class="mb-0"><strong>{{ changeDateFormat(items.created_at) }}</strong></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vld-parent">
      <loading
        :active.sync="isLoadingDashboard"
        :can-cancel="false"
        :is-full-page="fullPage"
        :height="30"
        :width="30"
      />
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import moment from 'moment'
// import VueChartist from 'v-chartist'
import Loading from 'vue-loading-overlay'

export default {
  components: {
    // 'vue-chartist': VueChartist,
    Loading,
  },
  data() {
    return {
      pagination: {},
      fullPage: true,
    }
  },
  created () {
    this.getDashboardData()
  },
  methods: {
    ...mapActions('dashboard', ['getDashboardData']),

    changeDateFormat (value) {
      return moment(value).format('DD MMMM YYYY')
    },
  },
  computed: {
    ...mapState('dashboard', {
      isLoadingDashboard: state => state.isLoadingDashboard,
      dashboard: state => state.dashboard,
      dataCart: state => state.dataCart,
      optionsCart: state => state.optionsCart,
      totalWeeklySales: state => state.totalWeeklySales,
    }),
  },
}
</script>
